import React from 'react';
import classnames from 'classnames';

import MaterialUIDialog from 'material-ui/Dialog';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';

import './Dialog.styl';

/**
 * @deprecated Please, use @material-ui/core/Dialog instead
 */
export default class Dialog extends React.PureComponent {
  render() {
    const {
      actions,
      autoScrollBodyContent = true,
      title,
      // eslint-disable-next-line
      titleClassName,
      showTitleBar = true,
      closeButton = true,
      className,
      ...remainingProps
    } = this.props;
    const styledActions =
      actions && actions.constructor === Array ? actions.filter(action => !!action) : actions;
    // titleClassName is supposed to take care of the class but for some
    // reason it is not working so wrap it and add class manually
    const newTitle = (
      <div className="ev-dialog-title">
        {title}
        {closeButton && (
          <div>
            <CloseIcon className="close-button" onClick={this.props.onRequestClose} />
          </div>
        )}
      </div>
    );
    return (
      <MaterialUIDialog
        className={classnames('ev-dialog', className)}
        actions={<ThemeProvider theme={lightTheme}>{styledActions}</ThemeProvider>}
        autoScrollBodyContent={autoScrollBodyContent}
        title={showTitleBar && newTitle}
        contentClassName="ev-dialog-content dialog-content"
        bodyClassName="ev-dialog-body"
        titleClassName="ev-dialog-title"
        actionsContainerClassName="ev-dialog-actions dialog-actions"
        {...remainingProps}>
        <ThemeProvider theme={lightTheme}>{this.props.children}</ThemeProvider>
      </MaterialUIDialog>
    );
  }
}
